import {
	AssessmentRepresentationStyle,
	DocumentType,
	QbrRepresentationStyle,
	UserType
} from "./../Documents/index";
import { Block, TableQueryFilter, DocumentPaperSize } from "./..";
import { QuoteTotal } from "../Documents";
import { UserData } from "../Users";
import { MergeTagVariable, LinkedEntityData } from "../Documents";
import { DocumentDefaults, DocumentPageDetails } from "../Documents/Revision";
import { VendorUserCompany, VendorUserData } from "../Vendor/User";

export interface TemplateViewKeys {
	blocks: { data: Block[] };
	draft_blocks?: { data: Block[] };
	user: UserData;
	created: Date;
	updated: Date;
	deleted: boolean;
}

export interface RecipientRoleData {
	blocks_to_sign: string[];
	index: number;
	user_type: UserType;
}

export class AssignUserToSignatureBlock {
	id = "";
	block_id = "";
	user_type?: UserType;
	index?: number;
}

export interface Template extends Partial<TemplateViewKeys> {
	block_list: string[];
	draft_block_list?: string[];
	company_id?: string;
	defaults: DocumentDefaults;
	description: string;
	document_type: DocumentType;
	id: string;
	linked_entity_data: LinkedEntityData[];
	merge_tag_custom_variables: MergeTagVariable[];
	merge_tags_system_variables: MergeTagVariable[];
	name: string;
	recipient_roles: RecipientRoleData[];
	thumbnail: string;
	total: QuoteTotal;
	user_id: string;
	qbr_representation_style?: QbrRepresentationStyle | null;
	assessment_representation_style?: AssessmentRepresentationStyle | null;
	has_pdf_block?: boolean;
	vendor?: VendorUserData;
	vendor_company?: VendorUserCompany;
	page_details?: DocumentPageDetails;
	is_quote_block_compact?: boolean;
	paper_size?: DocumentPaperSize;
	is_single_block?: boolean;
	rich_text_block_id?: string;
	rich_text_block?: Block | null;
	tag_ids?: string[];
}

export class TemplatesCount {
	[DocumentType.GENERIC_ORDER_FORM] = 0;
	[DocumentType.SALES_PRESENTATION] = 0;
	[DocumentType.QUOTE] = 0;
	[DocumentType.QBR] = 0;
	[DocumentType.PROPOSAL] = 0;
	[DocumentType.SPECIFIC_ORDER_FORM] = 0;
	[DocumentType.ASSESSMENT] = 0;
	[DocumentType.CONTRACT] = 0;
}

export interface TemplateListRequest {
	filters?: TableQueryFilter[];
	limit?: number;
	page?: number;
}

export interface TemplatesResponse {
	data: Template[];
	filtered_count_map: TemplatesCount;
}

export type UpdateTemplateRequest = Partial<
	Omit<Template, "updated" | "created" | "user">
> &
	Pick<Template, "id">;
export interface TemplateDetailsResponse {
	data: Template;
}

export enum TemplateFilterType {
	Global = "global",
	Custom = "custom"
}

export interface AddTemplateRequest {
	template_id?: string;
	document_id?: string;
	pdfUrl?: string;
	name: string;
	document_type?: string;
	description?: string;
	thumbnail_img?: string;
	qbr_representation_style?: QbrRepresentationStyle;
	assessment_representation_style?: AssessmentRepresentationStyle;
	paper_size?: DocumentPaperSize;
	is_single_block?: boolean;
}

export enum TemplateSidePanelEnum {
	EDIT = "EDIT",
	SETTINGS = "SETTINGS",
	ISSUES = "ISSUES",
	SAVED_BLOCKS_CK_EDITOR = "SAVED_BLOCKS_CK_EDITOR"
}

export enum Error {
	SUCCESS = "success",
	ERROR = "error"
}

export enum TemplateOwnerType {
	Global = "Global",
	Company = "Company"
}
